module.exports = __webpack_public_path__ + "img/lastNameEle.d5c497c9.svg";